<div class="mb-4" [ngClass]="{'billing-header-container':policyType!=='AUTO' && policyType!=='HOME' &&policyType!=='UMBRELLA'}">
    <ng-container *ngIf="policyType==='AUTO' || policyType==='HOME' || policyType==='UMBRELLA' ; else otherPolicyIcon">
        <img *ngIf="policyTypeImg" src={{policyTypeImg}} alt="car icon" width="24px" height="24px"
            class="billing-header-icon" />
    </ng-container>
    <ng-template #otherPolicyIcon>
        <div class="{{ policyType | lowercase }}-class paperless-bg">
        </div>
    </ng-template>
     <ng-container *ngIf="policy; else noPolicyDetails">
        <span class="col-526570 ml-2">
            {{ policy.displayType?.label }} &ndash; {{ policy?.policynumber?.policyNumber }}
        </span>
    </ng-container>
    <ng-template #noPolicyDetails>
        <span *ngIf="policyNumber && policyType" class="col-526570 ml-2">
            {{ (policyType ==='HOME') ? "Property" : policyType
                | translate | replaceUnderscoreWithSpace | titlecase
            }}
            &ndash; {{ policyNumber }}
        </span>
    </ng-template>
</div>